module.exports = require('@core/util/object');
